import TeachersPage from "@/pages/teachers";
import PrivateLayout from "@/components/layouts/private-layout";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/teachers/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateLayout>
      <TeachersPage />
    </PrivateLayout>
  );
}
